import _slicedToArray from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import React, { useState } from "react";
import { LeftCaret, RightCaret } from "../../Icons";
import { getPreviousIndex, getNextIndex } from "../SliderContainer";
import { HeroSlide } from "../HeroSlide";
import * as S from "./styles";

var LeftControl = function LeftControl(_ref) {
  var e = _ref.onClick;
  return React.createElement(S.LeftControl, {
    "aria-label": "Previous Slide",
    onClick: function onClick() {
      return e();
    }
  }, React.createElement(S.ControlIcon, {
    as: LeftCaret
  }));
},
    RightControl = function RightControl(_ref2) {
  var e = _ref2.onClick;
  return React.createElement(S.RightControl, {
    "aria-label": "Next Slide",
    onClick: function onClick() {
      return e();
    }
  }, React.createElement(S.ControlIcon, {
    as: RightCaret
  }));
};

export var HeroSlider = function HeroSlider(e) {
  var t = e.slideData,
      r = e.onSlide,
      o = __rest(e, ["slideData", "onSlide"]);

  var l = t.length,
      _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      a = _useState2[0],
      i = _useState2[1],
      _useState3 = useState("left"),
      _useState4 = _slicedToArray(_useState3, 2),
      n = _useState4[0],
      c = _useState4[1],
      _useState5 = useState(!0),
      _useState6 = _slicedToArray(_useState5, 2),
      s = _useState6[0],
      d = _useState6[1];

  return React.createElement(S.Slider, Object.assign({}, o), React.createElement(S.SlideContainer, null, React.createElement(HeroSlide, Object.assign({
    direction: n,
    activeSlide: a,
    firstLoad: s
  }, t[a]))), React.createElement(S.ControlsContainer, null, React.createElement(LeftControl, {
    onClick: function onClick() {
      return s && d(!1), i(getPreviousIndex(a, l)), c("right"), void (r && r("right"));
    }
  }), React.createElement(RightControl, {
    onClick: function onClick() {
      return s && d(!1), i(getNextIndex(a, l)), c("left"), void (r && r("left"));
    }
  })), React.createElement(S.Chips, {
    count: l,
    activeChip: a
  }));
};
export default HeroSlider;